// @flow

import React from 'react';

import {
  buildMultipleDataFetcher,
  buildSingleDataFetcher,
} from 'app/general/datafetchers/builders';
import {
  InfiniteListFetcher,
  type InfiniteListFetcherProps,
} from 'app/general/datafetchers/InfiniteListFetcher';
import {getDenormalizedListFactory} from 'app/utils/redux_v2';

import {
  fetchProcesses,
  convertLocationParamsToFetchParams,
} from 'app/process/actions';
import type {ProcessType} from 'app/process/types';

export const denormalizeProcessesList = getDenormalizedListFactory<ProcessType>(
  (state) => state.processArea
);

export const MultipleStoredProcessesFetcher =
  buildMultipleDataFetcher<ProcessType>(
    convertLocationParamsToFetchParams,
    // $FlowFixMe - flow doesn't understand redux-thunk magic
    fetchProcesses,
    denormalizeProcessesList
  );

export const StoredProcessesFetcher = buildSingleDataFetcher<ProcessType>(
  MultipleStoredProcessesFetcher
);

export const ProcessesInfiniteListFetcher = (
  props: InfiniteListFetcherProps<ProcessType>
) => (
  <InfiniteListFetcher
    DataFetcher={MultipleStoredProcessesFetcher}
    {...props}
  />
);
